import { useCallback, useMemo } from "react";

import { useIntl } from "react-intl";

import { buildAmountText } from "./build-amount-text";
import { formatAmountString } from "./format-amount-string";
import { getAmountSeparators } from "./get-amount-separators";

/**
 * Отображение сумм по текущей локали: разделитель дроби и разрядов тысяч.
 * Глубину не меняет - сколько знаков пришло, столько и выводим.
 * Для копирования и запросов нужно исходное значение.
 *
 * formatAmount - только число: "89800.0999" -> "89 800,0999".
 * formatAmountWithCode - число с кодом актива: "89 800,0999 USDT".
 */
export const useFormatAmount = () => {
  const { locale } = useIntl();
  const separators = useMemo(() => getAmountSeparators(locale), [locale]);

  const formatAmount = useCallback(
    (value: null | string | undefined): string => {
      return value == null ? "" : formatAmountString(value, separators);
    },
    [separators],
  );

  const formatAmountWithCode = useCallback(
    (value: null | string | undefined, code: string): string => {
      return buildAmountText({ amount: formatAmount(value), code });
    },
    [formatAmount],
  );

  return { formatAmount, formatAmountWithCode };
};
